// URL-Encoding der Planungsassistent-Loading-Cases — eigene Datei statt Export aus
// planning-assistant.component, damit Aufrufer (Dashboard, Ticketseite) die Funktionen
// ohne Import der kompletten PA-Wurzelkomponente nutzen können
import type { Router } from "@angular/router";

export function encodePlanTicketsLoadingCaseParams(
  router: Router,
  ticket_id: number | string,
  config?: {
    additional_ticket_ids?: (number | string)[];
    technician_dates?: { user_id: number | string; utc_day_timestamps: number[] }[];
    project_ids?: (number | string)[];
  },
): string {
  return router.serializeUrl(
    router.createUrlTree(["/a/planning_assistant"], {
      queryParams: {
        mode: "plan_ticket",
        ticket_id: ticket_id,
        auto_select: config?.additional_ticket_ids,
        technician_dates: config?.technician_dates
          ? config?.technician_dates.map((td) => `${td.user_id}:${td.utc_day_timestamps.join(";")}`)
          : undefined,
        project_ids: config?.project_ids,
      },
    }),
  );
}

export function encodePlanTechnicianLoadingCaseParams(
  router: Router,
  technician_id: number | string,
  config?: {
    ticket_ids?: (number | string)[];
    project_ids?: (number | string)[];
    day_timestamps?: number[];
  },
): string {
  return router.serializeUrl(
    router.createUrlTree(["/a/planning_assistant"], {
      queryParams: {
        mode: "plan_technician",
        plan_technician_id:
          technician_id + (config?.day_timestamps?.length ? `:${config.day_timestamps.join(";")}` : ""),
        auto_select: config?.ticket_ids,
        project_ids: config?.project_ids,
      },
    }),
  );
}
